import * as React from "react"
import * as classNames from "classnames";

const Button = ({ primary = false, children, loading = false, className = "", type = "button" }) => {
  return (
    <button type={type} className={classNames(
      className,
      "py-2 px-3",
      "inline-flex items-center",
      "rounded-lg border",
      "relative hover:before:bg-darken before:left-0 before:top-0 before:absolute before:w-full before:h-full",
      primary ?
        "bg-accent text-accent-text border-transparent" :
        "bg-transparent border-accent",
      "hover:shadow-xl",
    )}>
      {!loading && children}
      {loading && <span className={classNames(
        "animate-spin inline-block w-4 h-4 border-[3px] mx-2 my-1 rounded-full",
        "border-current border-t-transparent text-white",
        { "text-accent-text": primary },
      )} role="status" aria-label="loading" />}
    </button>
  )
}

export default Button;
